var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileOfflineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13716",
    "data-name": "Group 13716",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.539,
    height: 45.747,
    viewBox: "0 0 48.539 45.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5291",
    "data-name": "Rectangle 5291",
    width: 48.539,
    height: 45.747,
    fill: "#ff002a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13675",
    "data-name": "Group 13675",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45569",
    "data-name": "Path 45569",
    d: "M48.539,37.494v2.08a7.344,7.344,0,0,1-6.027,6.043c-12.139.173-24.322.173-36.461,0A7.344,7.344,0,0,1,.025,39.574c.057-.661-.077-1.436,0-2.08.058-.481.378-1.141.5-1.633L18.083,3.551a7.2,7.2,0,0,1,11.787-.9c6.2,10.98,12.148,22.129,18.172,33.214.118.491.438,1.151.5,1.633M23.688,11.7a2.926,2.926,0,0,0-2.237,2.78c.215,4.534-.328,9.4-.016,13.893.282,4.07,5.41,4.069,5.693,0,.309-4.445-.242-9.239,0-13.72a2.89,2.89,0,0,0-3.44-2.953m3.385,25.435a2.792,2.792,0,1,0-2.792,2.787,2.789,2.789,0,0,0,2.792-2.787",
    transform: "translate(0 0)",
    fill: "#ff002a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileOfflineIcon);
export default __webpack_public_path__ + "static/media/profile-offline-icon.869c9491af2d262933cc8b665b4356b2.svg";
export { ForwardRef as ReactComponent };